<div class="modal-container page-content property">
  <div class="modal-header d-flex justify-content-between border-0">
    <h5 class="modal-heading">Edit Profile</h5>
    <p class="modal-clost-btn" (click)="bsModalRef?.hide()" aria-label="Close">&times;</p>
  </div>
  <div class="modal-body border-top">
    <div class="form-section visible mt-0 p-0 mb-3 border-0">
      <label class="form-label mt-2">Your name <span class="text-danger">*</span> </label>
      <div class="row">
        <div class="col-6">
          <app-input [formGrp]="form" formCtrlName="first_name" text label="First name"></app-input>
        </div>
        <div class="col-6">
          <app-input [formGrp]="form" formCtrlName="last_name" text label="Last name"></app-input>
        </div>
      </div>
    </div>

    <div class="form-section visible mt-0 p-0 mb-3 border-0">
      <label class="form-label mt-2">Email Address </label>
      <app-input [formGrp]="form" formCtrlName="email" email label="Email"></app-input>
    </div>

    <div class="form-section visible mt-0 p-0 mb-3 border-0">
      <label class="form-label mt-2">Phone number <span class="text-danger">*</span> </label>
      <div class="row">
        <!--div class="col-4">
          <app-country-dropdown [countryCodes]="countryCodes"></app-country-dropdown>
        </div-->
        <div class="col-12">
          <app-input [formGrp]="form" formCtrlName="phone" tel label="Phone number"></app-input>
        </div>
      </div>
    </div>

    <!-- <div class="form-section visible mt-0 p-0 mb-3 border-0">
      <label class="form-label mt-2">Address </label>
      <app-input [formGrp]="form" formCtrlName="address" textarea label="Address"></app-input>
    </div> -->
    <app-button (onclick)="save()" [disabled]="form.invalid || loading" primary>
      {{loading ? 'Saving...': 'Save & Close'}}
    </app-button>
  </div>
</div>